module.exports = __webpack_public_path__ + "img/b1 (6).baca65be.png";